<div *ngIf="booking">
  <div class="flex justify-content-between align-items-start gap-3 flex-wrap">
    <div>
      <div class="flex align-items-center gap-2 flex-wrap">
        <h3 class="m-0">{{ booking.orderNumber }}</h3>
        <pill>{{ booking.bookingStatus }}</pill>
        <pill
          *ngIf="booking.supplierId"
          backgroundColour="bg-orange-50"
          textColour="text-orange-700"
        >
          <i class="fa fa-truck mr-1"></i>Assigned to {{ booking.supplierName || 'supplier' }}
        </pill>
        <a target="_blank" href="/app/jobscreen/{{ booking.jobId }}">
          Job {{ booking.jobNumber }}
        </a>
      </div>
    </div>

    <div class="flex align-items-center gap-2">
      <span *ngIf="rechecking" class="text-gray-500">
        <i class="fa fa-spin fa-spinner mr-1"></i>Re-checking&hellip;
      </span>
      <button
        pButton
        type="button"
        icon="fa fa-refresh"
        class="ui-button-secondary"
        title="Re-run the checks for this booking now, instead of waiting for the next scheduled pass"
        pTooltip="Re-run the checks for this booking now, instead of waiting for the next scheduled pass"
        [disabled]="rechecking"
        (click)="recheckRequested.emit()"
      ></button>
      <order-booking-assigned-to
        [assigneeId]="booking.assigneeId"
        [assigneeName]="booking.assigneeName"
        (assignedUserChange)="handleAssignedUserChange($event)"
      ></order-booking-assigned-to>
    </div>
  </div>

  <div class="text-gray-700 mt-2">
    {{ booking.customerName }}
    <span class="text-gray-600" *ngIf="booking.customerPriority">
      ({{ AMPriorityEnum[booking.customerPriority] }})
    </span>
    <span *ngFor="let part of scopeParts"> &middot; {{ part }}</span>
  </div>

  <div class="text-gray-700 mt-1 mb-3" *ngIf="firstTask">
    {{ firstTask.pickupLocation }},
    {{ firstTask.pickupEarliestDateTime | datex : 'ddd, DD MMM' }} by
    {{ firstTask.pickupLatestDateTime | datex : 'HH:mm' }}
    &rarr;
    {{ lastTask.dropoffLocation }},
    {{ lastTask.dropoffEarliestDateTime | datex : 'ddd, DD MMM' }} by
    {{ lastTask.dropoffLatestDateTime | datex : 'HH:mm' }}
  </div>

  <booking-issue-card
    *ngFor="let issue of orderedIssues"
    [issue]="issue"
    [booking]="booking"
    (issueChanged)="issueChanged.emit()"
  ></booking-issue-card>
</div>
